import React, { useState } from "react";
import { MorphSvg } from "../MorphSvg";
import { MorphPaths } from "../MorphSvg/paths";
import { Sticker, StickerProps } from "../Sticker";

interface MorphStickerProps extends StickerProps {
  path: keyof typeof MorphPaths;
  svgClassName?: string;
}

const MorphSticker: React.FC<MorphStickerProps> = ({
  path,
  svgClassName,
  ...props
}) => {
  const [stickerOpen, setStickerOpen] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  return (
    <Sticker
      onStart={() => setIsDragging(true)}
      onEnd={() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setIsDragging(false);
          });
        });
      }}
      {...props}
    >
      <MorphSvg
        morph={stickerOpen}
        className={svgClassName}
        morphObject={MorphPaths[path]}
        onClick={!isDragging ? () => setStickerOpen(!stickerOpen) : undefined}
      />
    </Sticker>
  );
};

export { MorphSticker };
